import React, { useState, useEffect, useRef } from 'react';

export function ConfirmationSheet({ isVisible, onConfirm, onCancel }) {
    const [countdown, setCountdown] = useState(3);
    const [isConfirmEnabled, setIsConfirmEnabled] = useState(false);
    const [startY, setStartY] = useState(null);
    const [currentY, setCurrentY] = useState(null);
    const sheetRef = useRef(null);
    const timerRef = useRef(null);

    // Блокируем прокрутку body при открытии шторки
    useEffect(() => {
        if (isVisible) {
            document.body.style.overflow = 'hidden';
            document.body.classList.add('sheet-open');
        } else {
            document.body.style.overflow = '';
            document.body.classList.remove('sheet-open');
        }

        return () => {
            document.body.style.overflow = '';
            document.body.classList.remove('sheet-open');
        };
    }, [isVisible]);

    useEffect(() => {
        if (isVisible) {
            setCountdown(3);
            setIsConfirmEnabled(false);

            timerRef.current = setInterval(() => {
                setCountdown((prev) => {
                    if (prev <= 1) {
                        clearInterval(timerRef.current);
                        setIsConfirmEnabled(true);
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
        }

        return () => {
            if (timerRef.current) {
                clearInterval(timerRef.current);
            }
        };
    }, [isVisible]);

    const handleTouchStart = (e) => {
        setStartY(e.touches[0].clientY);
    };

    const handleTouchMove = (e) => {
        if (startY === null) return;

        const currentTouchY = e.touches[0].clientY;
        const diff = currentTouchY - startY;

        if (diff > 0) {
            e.preventDefault();
            setCurrentY(diff);

            if (sheetRef.current) {
                const maxTranslate = window.innerHeight * 0.5;
                const translateY = Math.min(diff, maxTranslate);
                sheetRef.current.style.transform = `translateY(${translateY}px)`;
            }
        }
    };

    const handleTouchEnd = (e) => {
        if (startY === null) return;

        const diff = currentY || 0;

        if (diff > 100) {
            handleCancel();
        }

        if (sheetRef.current) {
            sheetRef.current.style.transform = '';
        }

        setStartY(null);
        setCurrentY(null);
    };

    const handleMouseDown = (e) => {
        setStartY(e.clientY);

        const handleMouseMove = (e) => {
            if (startY === null) return;

            const diff = e.clientY - startY;

            if (diff > 0) {
                setCurrentY(diff);

                if (sheetRef.current) {
                    const maxTranslate = window.innerHeight * 0.5;
                    const translateY = Math.min(diff, maxTranslate);
                    sheetRef.current.style.transform = `translateY(${translateY}px)`;
                }
            }
        };

        const handleMouseUp = (e) => {
            const diff = currentY || 0;

            if (diff > 100) {
                handleCancel();
            }

            if (sheetRef.current) {
                sheetRef.current.style.transform = '';
            }

            setStartY(null);
            setCurrentY(null);

            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
        };

        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
    };

    const handleConfirm = () => {
        if (isConfirmEnabled) {
            onConfirm();
        }
    };

    const handleCancel = () => {
        if (timerRef.current) {
            clearInterval(timerRef.current);
        }
        onCancel();
    };

    return (
        <div className={`confirmation-sheet-wrapper ${isVisible ? 'visible' : ''}`}>
            <div
                className="sheet-overlay"
                onClick={handleCancel}
            />

            <div
                ref={sheetRef}
                className="confirmation-sheet"
            >
                <div className="sheet-content">
                    <div
                        className="sheet-drag-handle"
                        onTouchStart={handleTouchStart}
                        onTouchMove={handleTouchMove}
                        onTouchEnd={handleTouchEnd}
                        onMouseDown={handleMouseDown}
                    >
                        <div className="drag-indicator" />
                    </div>

                    <h3 className="sheet-title">
                        Внимание
                    </h3>

                    <p className="sheet-text">
                        У вас уже есть ключ
                    </p>

                    <div className="custom-content-box">
                        <p className="custom-content-text">
                            Вы уверены что Вы хотите купить еще один ключ?

                            Вы можете продлить старый ключ, нажав на кнопку Продлить в меню ключей.
                        </p>
                    </div>

                    <div className="sheet-buttons">
                        <button
                            className="sheet-button sheet-button-cancel"
                            onClick={handleCancel}
                        >
                            Отмена
                        </button>
                        <button
                            className={`sheet-button sheet-button-confirm btn${!isConfirmEnabled ? 'disabled' : ''}`}
                            onClick={handleConfirm}
                            disabled={!isConfirmEnabled}
                        >
                            {isConfirmEnabled ? 'Продолжить покупку' : `Подождите ${countdown}с`}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}